import { Extension, Person, Policy } from "@mui/icons-material";
import {
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appRoutes } from "../../../constant/constant";

const AdminMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <Divider />
      <List sx={{ py: 1 }}>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.personnel)}
            selected={isActive(appRoutes.personnel)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Person
                sx={{
                  color: isActive(appRoutes.personnel)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Personnels"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.personnel) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>

      <Divider />
      <List sx={{ py: 1 }}>
        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.partenaire)}
            selected={isActive(appRoutes.partenaire)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Policy
                sx={{
                  color: isActive(appRoutes.partenaire)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Partenaires"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.partenaire) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>

        <ListItem
          disablePadding
          sx={{ borderRadius: 2, overflow: "hidden", my: 0.5 }}
        >
          <ListItemButton
            onClick={() => navigate(appRoutes.structure)}
            selected={isActive(appRoutes.structure)}
            sx={{
              borderRadius: 2,
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "success.light",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
              },
              "&.Mui-selected": {
                backgroundColor: "success.main",
                color: "common.white",
                "& .MuiListItemIcon-root": {
                  color: "warning.main",
                },
                "&:hover": {
                  backgroundColor: "success.dark",
                },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>
              <Extension
                sx={{
                  color: isActive(appRoutes.structure)
                    ? "warning.main"
                    : "text.secondary",
                  transition: "color 0.3s ease",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Structures"
              primaryTypographyProps={{
                fontWeight: isActive(appRoutes.structure) ? "bold" : "normal",
              }}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </>
  );
};

export default AdminMenu;
